import {
  type Analytics,
  type CustomEventName,
  type EventNameString,
  type EventParams,
  initializeAnalytics,
  isSupported,
  setUserId as fbSetUserId,
  logEvent as fbLogEvent,
} from "firebase/analytics";

export default defineNuxtPlugin(async () => {
  const firebaseApp = useFirebaseApp();

  let analyticsInstance: Analytics | null = null;
  if (await isSupported()) {
    analyticsInstance = initializeAnalytics(firebaseApp);
  }

  const analytics = {
    setUserId: (id: string | null) => {
      if (analyticsInstance) {
        fbSetUserId(analyticsInstance, id);
      }
    },
    logEvent<T extends string>(
      eventName: EventNameString | CustomEventName<T>,
      eventParams?: EventParams,
    ) {
      if (analyticsInstance) {
        // Using the imported and aliased logEvent function
        // @ts-expect-error - Firebase Analytics logEvent type inference is overly strict
        fbLogEvent(analyticsInstance, eventName, eventParams);
        console.log("Log:", { event: eventName, params: eventParams });

        const { $clientPosthog } = useNuxtApp();
        $clientPosthog?.capture(eventName, eventParams);
      }
    },
  };

  return {
    provide: {
      analytics,
    },
  };
});
